import {
  DOWNLOAD_APP_URL_MAC,
  DOWNLOAD_APP_URL_WINDOWS,
  INTERCOM_SETTINGS,
} from 'Constants/env';
import * as intercom from './intercomWrapper';

const MACOS_PLATFORMS = [
  'Macintosh',
  'MacIntel',
  'MacPPC',
  'Mac68K',
  'darwin',
];

export const openFeedbackSurvey = () => {
  intercom.startSurvey(Number(INTERCOM_SETTINGS.feedbackSurveyId));
};

export const downloadDesktopApp = () => {
  const url = MACOS_PLATFORMS.includes(window.navigator.platform)
    ? DOWNLOAD_APP_URL_MAC
    : DOWNLOAD_APP_URL_WINDOWS;
  window.open(url, '_blank');
};
